import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import { AmplifyEventBus } from 'aws-amplify-vue'
import Inputmask from 'inputmask'
import _ from 'lodash'
import { GetUrlParameter } from '@/utils/GameUtils'

@Component
export default class SignUp extends Vue {
  
  // @ts-ignore
  aff_id =  window.$cookies.get('ClickID') || GetUrlParameter('ClickID') || ''
  bonus_id = GetUrlParameter('BonusID') || ''

  signUpConfig = {
    hideAllDefaults: true,
    signUpFields: [
      {
        label: 'Email',
        key: 'email',
        required: true,
        displayOrder: 1,
        type: 'string'
      },
      {
        label: '',
        key: 'given_name',
        required: true,
        displayOrder: 2,
        type: 'hidden',
        value: 'First Name',
      },
      {
        label: '',
        key: 'family_name',
        required: true,
        displayOrder: 3,
        type: 'hidden',
        value: 'Last Name',
      },
      {
        label: 'Date of birth',
        key: 'birthdate',
        required: true,
        displayOrder: 7,
        type: 'string',
      },
      {
        label: 'Username',
        key: 'username',
        required: true,
        displayOrder: 5,
        type: 'string',
        signUpWith: true,
      },
      {
        label: 'Password',
        key: 'password',
        required: true,
        displayOrder: 6,
        type: 'password'
      },
      {
        label: 'Bonus',
        custom: true,
        key: 'custom:promo_ct_num',
        required: false,
        displayOrder: 8,
        type: 'string',
        value: this.bonus_id
      },
      {
        label: '',
        key: 'custom:affiliate_tr_id',
        required: false,
        displayOrder: 9,
        type: 'hidden',
        value: this.aff_id,
      },
    ]
  }

  private mounted() {
    /*if (this.aff_id) {
      const affidNode: HTMLInputElement | null = document.querySelector('div[signupfield="custom:affiliate_tr_id"] input')
      if (affidNode) {
        affidNode.disabled = true
      }
    }*/

    const dict = {
      'qp': {
        'Username cannot be of email format, since user pool is configured for email alias.': 'Usernames cannot be email addresses',
        'PreSignUp failed with error That email address has already signed up - have you forgotten your password?.': 'That email address has already signed up - have you forgotten your password?'
      }
    }

    //@ts-ignore
    this.$Amplify.I18n.putVocabularies(dict)

    //@ts-ignore
    this.$Amplify.I18n.setLanguage('qp')

    const birthdayNode: HTMLInputElement | null = document.querySelector('div[signupfield="birthdate"] input')

    if (birthdayNode) {
      const dateMask = new Inputmask({
        alias: 'datetime',
        inputFormat: 'mm/dd/yyyy',
      })

      dateMask.mask(birthdayNode)

      //@ts-ignore
      heap.track('game:signup:init')
    }

    document.onkeyup = function(evt) {
      
      if (evt.target === null) { return }

      // @ts-ignore
      const refNode = evt.target.parentElement.parentElement
      const refName = refNode.getAttribute('signupfield')

      if (refName === 'username' || refName === 'email' ) {
        // @ts-ignore
        evt.target.value = evt.target.value.toLowerCase()
      }
    }
  }

  private render(h: any) {
    return (
      <DefaultLayout>
        <svg viewBox='0 0 977 977'>
          <use xlinkHref='#qp'></use>
        </svg>

        <h2 class='signups-closed'>Signups are currently disabled</h2>
        
        {
          //<amplify-sign-up signUpConfig={this.signUpConfig}></amplify-sign-up>
        }
      </DefaultLayout>
    );
  }
}
